import { render, staticRenderFns } from "./CenterPoints.vue?vue&type=template&id=724db868&"
import script from "./CenterPoints.vue?vue&type=script&lang=ts&"
export * from "./CenterPoints.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports